import { css } from "styled-components";

// Positions an element in the centre of the screen
export const absoluteCentre = css`
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`;
